import {
  configNewRelic,
  INewRelicConfig,
} from "@origin-digital/reporting-client";
import { EnvironmentNames } from "@origin-digital/platform-enums";
import { isNative } from "@origin-digital/platform-helpers";

const newRelicConfig: Record<"prod" | "staging", Partial<INewRelicConfig>> = {
  prod: {
    apiKey: "20660d24ad1850940e1985959b97c8345b53NRAL",
    logLevel: "warn",
    consoleLogLevel: "none",
  },
  staging: {
    apiKey: "76cb225157457a776b398513c9aed3e2FFFFNRAL",
    logLevel: "info",
    consoleLogLevel: "none",
  },
};

// Configure New Relic Log Ingestion with defaults based on the loaded app and environment
export const configNRLogger = () => {
  const environment = window.oetal.env.name as EnvironmentNames;
  if (!newRelicConfig[environment]) {
    // No config for this environment
    return;
  }
  const appName = window.oetal.apps?.[0]?.name ?? "tal-client";

  if (environment === "prod" || environment === "staging") {
    configNewRelic({
      ...newRelicConfig[environment],
      isNative: isNative(),
      appName,
      endpoint: "https://log-api.newrelic.com/log/v1",
      sourceEnv: environment,
    } as INewRelicConfig);
  }
};
